export default "__VITE_ASSET__DORuLr4___"